import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-af91a120"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-detail-top"
};
const _hoisted_2 = {
  class: "project-detail-top-left"
};
const _hoisted_3 = {
  class: "images"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "project-detail-top-right"
};
const _hoisted_6 = {
  class: "tag-box"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "horizontal-line"
}, null, -1));
const _hoisted_8 = {
  class: "video_link"
};
const _hoisted_9 = {
  class: "project_type"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  class: "horizontal-line"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "package_title"
}, [/*#__PURE__*/_createElementVNode("h3", {
  style: {
    "font-weight": "550",
    "font-size": "20px"
  }
}, " 请选择您需要获取的套餐(详细内容见牛站介绍)")], -1));
const _hoisted_12 = {
  class: "package_type"
};
const _hoisted_13 = {
  class: "package_price"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "550"
  }
}, "套餐价格：", -1));
const _hoisted_15 = {
  key: 0,
  style: {
    "font-weight": "550",
    "color": "red"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "20px"
  }
}, "￥", -1));
const _hoisted_17 = {
  style: {
    "font-size": "30px"
  }
};
const _hoisted_18 = {
  key: 1,
  style: {
    "font-weight": "550"
  }
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "20px",
    "color": "red"
  }
}, "￥", -1));
const _hoisted_20 = {
  style: {
    "font-size": "30px",
    "color": "#ff4d4f"
  }
};
const _hoisted_21 = {
  class: "buy_button",
  style: {
    "text-align": "center"
  }
};
const _hoisted_22 = {
  class: "agreement-wrapper"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px"
  }
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/userAgreement.html",
  target: "_blank"
}, "用户协议 "), /*#__PURE__*/_createTextVNode(" 、 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/payAgreement.html",
  target: "_blank"
}, "购买协议 "), /*#__PURE__*/_createTextVNode(" 和 "), /*#__PURE__*/_createElementVNode("a", {
  href: "/agreement/privacyAgreement.html",
  target: "_blank"
}, " 隐私政策")], -1));
import { onMounted, ref, watch } from 'vue';
import { ClockCircleOutlined, EyeOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue';
import dayjs from "dayjs";
import { XiaoniuFrontedControllerService } from "../../../../generated/services/XiaoniuFrontedControllerService";
import { message } from "ant-design-vue";
import { useLoginUserStore } from "@/store/loginUser";
import ACCESS_ENUM from '@/access/ACCESS_ENUM';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectDetailTop',
  props: {
    projectDetail: {},
    dictList: {},
    projectViewCount: {},
    projectBuyCount: {}
  },
  setup(__props) {
    const buyButtonText = ref('正在为您火速下单中...3秒');
    const packageType = ref("0");
    const agreementChecked = ref(false);
    const formattedCreateDate = ref('');
    const links = ref([]);
    const priceList = ref([]);
    const packagePrice = ref(null);
    const isClickBuy = ref(false);
    const loginUserStore = useLoginUserStore();
    const projectType = ref('');
    const formattedProjectViewCount = ref('0');
    const formattedProjectBuyCount = ref('0');
    const getImageUrl = item => {
      return item.imageUrl === null ? require("@/assets/default-project-detail-in.png") : item.imageUrl;
    };
    const props = __props;
    const startCountdown = async () => {
      buyButtonText.value = `正在为您火速下单中...3秒`;
      if (isClickBuy.value) return; // 防止重复点击
      isClickBuy.value = true;
      let countdown = 3;
      const interval = setInterval(async () => {
        countdown -= 1;
        buyButtonText.value = `正在为您火速下单中...${countdown}秒`;
        if (countdown <= 0) {
          clearInterval(interval);
          //如果是普通用户   或者说只要选择了套餐二或者三 调用下单接口
          if (loginUserStore.loginUser?.userRole === ACCESS_ENUM.USER) {
            const orderRes = await addOrder();
            if (orderRes.code === 200) {
              //调用支付接口
              const payRes = await payOrder(orderRes.data);
              //跳转到支付页面
              window.location = payRes.paymentUrl;
            } else {
              //下单失败  清除定时器 恢复按钮原始状态 提示错误信息
              message.error(orderRes.msg);
              isClickBuy.value = false;
            }
          } else {
            //调用下单接口同时完成链接的操作
            const orderRes = await addMemberOrder();
            if (orderRes.code === 200) {
              message.success("下单成功,请到我的订单界面查收~");
              isClickBuy.value = false;
            } else {
              message.error(orderRes.msg);
              isClickBuy.value = false;
            }
          }
        }
      }, 1000);
    };
    const payOrder = async orderNo => {
      const res = await XiaoniuFrontedControllerService.payUsingPost(orderNo);
      return res;
    };
    const addOrder = async () => {
      //添加支付订单
      const projectOrder = {
        ...props.projectDetail,
        packageType: Number(packageType.value),
        price: Number(packagePrice.value)
      };
      const res = await XiaoniuFrontedControllerService.addUsingPost13(projectOrder);
      return res;
    };
    const addMemberOrder = async () => {
      //添加会员下单支付订单
      const projectOrder = {
        ...props.projectDetail,
        packageType: Number(packageType.value),
        price: Number(0)
      };
      const res = await XiaoniuFrontedControllerService.addMemberOrder(projectOrder);
      return res;
    };
    //下单
    const buy = () => {
      //查询用户登陆状态
      if (!loginUserStore.isLogin) {
        message.error('您尚未登录~');
        return;
      }
      //检查是否勾选同意
      if (!agreementChecked.value) {
        message.error('未勾选同意协议~');
        return;
      }
      //设置定时器3秒  同时进行下单操作
      startCountdown();
    };
    watch([() => props.projectDetail, () => props.dictList, () => props.projectViewCount, () => props.projectBuyCount],
    // 观察的数据源
    ([newDetail, newDictList, newProjectViewCount, newProjectBuyCount]) => {
      if (newDetail && newDetail.createTime) {
        formattedCreateDate.value = dayjs(newDetail.createTime).format('YYYY-MM-DD');
      }
      if (newDetail && newDetail.link) {
        //将link以||分割，分为一个数组
        links.value = newDetail.link.split(' || ');
      }
      if (newDetail && newDictList) {
        const dic = newDictList.find(item => Number(item.dictValue) === Number(newDetail.type));
        projectType.value = dic?.dictLabel;
      }
      if (newProjectViewCount) {
        //浏览量如果超过了万 显示为万
        if (newProjectViewCount > 10000) {
          formattedProjectViewCount.value = (newProjectViewCount / 10000).toFixed(2) + '万';
        } else {
          formattedProjectViewCount.value = newProjectViewCount.toString();
        }
      }
      if (newProjectBuyCount) {
        //浏览量如果超过了万 显示为万
        if (newProjectBuyCount > 10000) {
          formattedProjectBuyCount.value = (newProjectBuyCount / 10000).toFixed(2) + '万';
        } else {
          formattedProjectBuyCount.value = newProjectBuyCount.toString();
        }
      }
    }, {
      immediate: true
    });
    const packageChange = value => {
      packagePrice.value = priceList.value[value];
    };
    const getPackagePrice = async () => {
      //获取套餐价格信息
      const res = await XiaoniuFrontedControllerService.listUsingGet15();
      if (res.code == 200) {
        priceList.value.push(res.rows[0].otherPrice);
        priceList.value.push(res.rows[0].otherPrice1);
        priceList.value.push(res.rows[0].otherPrice2);
        packagePrice.value = priceList.value[0];
      }
    };
    onMounted(() => {
      getPackagePrice();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 10,
          lg: 11,
          xl: 11,
          class: "el-col-wrapper"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: getImageUrl(_ctx.projectDetail)
          }, null, 8, _hoisted_4)])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 14,
          lg: 13,
          xl: 13
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("h1", null, _toDisplayString(_ctx.projectDetail.name), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_tag, {
            type: "primary",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ClockCircleOutlined), {
              class: "icon"
            }), _createTextVNode(" 发布" + _toDisplayString(formattedCreateDate.value), 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "success",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(EyeOutlined), {
              class: "icon"
            }), _createTextVNode(" 浏览" + _toDisplayString(formattedProjectViewCount.value) + "次 ", 1)]),
            _: 1
          }), _createVNode(_component_el_tag, {
            type: "warning",
            class: "el-tag-span"
          }, {
            default: _withCtx(() => [_createVNode(_unref(ShoppingCartOutlined), {
              class: "icon"
            }), _createTextVNode(" 购买" + _toDisplayString(formattedProjectBuyCount.value) + "次 ", 1)]),
            _: 1
          })]), _hoisted_7, _createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (item, index) => {
            return _openBlock(), _createElementBlock("p", {
              key: index
            }, [_createTextVNode("视频链接： "), _createVNode(_component_el_link, {
              href: item,
              type: "primary",
              target: "_blank"
            }, {
              default: _withCtx(() => [_createTextVNode("☛☛点我进入☚☚ ")]),
              _: 2
            }, 1032, ["href"])]);
          }), 128))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, "项目类型：" + _toDisplayString(projectType.value), 1)]), _hoisted_10, _hoisted_11, _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_radio_group, {
            modelValue: packageType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => packageType.value = $event),
            onChange: packageChange
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: "0"
            }, {
              default: _withCtx(() => [_createTextVNode("套餐一(源码)")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: "1"
            }, {
              default: _withCtx(() => [_createTextVNode("套餐二(源码+部署)")]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: "2"
            }, {
              default: _withCtx(() => [_createTextVNode("套餐三(技术套餐)")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _unref(loginUserStore).loginUser?.userRole === _unref(ACCESS_ENUM).NOT_LOGIN || _unref(loginUserStore).loginUser?.userRole === _unref(ACCESS_ENUM).USER ? (_openBlock(), _createElementBlock("span", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, _toDisplayString(packagePrice.value), 1)])) : (_openBlock(), _createElementBlock("span", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, [_createElementVNode("s", null, _toDisplayString(packagePrice.value), 1)])]))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_checkbox, {
            modelValue: agreementChecked.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => agreementChecked.value = $event)
          }, {
            default: _withCtx(() => [_createTextVNode("我已阅读并同意平台 ")]),
            _: 1
          }, 8, ["modelValue"]), _hoisted_23]), !isClickBuy.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            style: {
              "width": "100px"
            },
            type: "primary",
            size: "large",
            onClick: buy
          }, {
            default: _withCtx(() => [_createTextVNode("下单 ")]),
            _: 1
          })) : _createCommentVNode("", true), isClickBuy.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            style: {
              "width": "200px"
            },
            type: "primary",
            size: "large",
            disabled: ""
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(buyButtonText.value), 1)]),
            _: 1
          })) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});